export default "__VITE_ASSET__CX32JPrd__"